import { render, staticRenderFns } from "./configurations-result-card-footer.component.vue?vue&type=template&id=e7b47262&scoped=true"
import script from "./configurations-result-card-footer.component.vue?vue&type=script&lang=ts"
export * from "./configurations-result-card-footer.component.vue?vue&type=script&lang=ts"
import style0 from "./configurations-result-card-footer.component.vue?vue&type=style&index=0&id=e7b47262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b47262",
  null
  
)

export default component.exports